export type KVEntry = [number, string, string];

export const keyValueEntries = (
  kv: { [index: string]: string },
  excludeProperties: string[] = []
): KVEntry[] => {
  return Object.entries(kv)
    .filter((v: [string, string]): boolean => !excludeProperties.includes(v[0]))

    .map((v: [string, string], index: number): KVEntry => {
      return [index, v[0], v[1]];
    });
};
